import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css'
import 'pretty-checkbox/dist/pretty-checkbox.min.css';

// Containers
import { DefaultLayout } from './containers';
// Pages
import { Login, Page404, Page500, Register, PasswordReset, PasswordResetConfirm } from './views/Pages';
import withAuth from "./components/withAuth";
import Lock from "./views/Pages/Lock";
// Containers
import Full from './containers/Full/'
// import { renderRoutes } from 'react-router-config';

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
            <Route exact path="/login" name="Login Page" component={Login}/>
            <Route exact path="/lock" name="Login Page" component={Lock}/>
            <Route exact path="/register/:referral/:email" name="Register Page" component={Register}/>
            <Route exact path="/passwordReset" name="Password Reset Page" component={PasswordReset}/>
            <Route exact path="/passwordResetConfirm/:secret/:email" name="Confirm New Password" component={PasswordResetConfirm}/>
            <Route exact path="/404" name="Page 404" component={Page404}/>
            <Route exact path="/500" name="Page 500" component={Page500}/>
            <Route path="/" name="Home" component={withAuth(DefaultLayout)}/>
        </Switch>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js